import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../Layout.vue";
import i18n from "@/i18n";

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        component: Layout,
        children: [
            {
                path: "",
                name: "Home",
                component: () => import("../views/Home.vue"),
                meta: {
                    requiresAuth: true,
                    isAdmin: false,
                    permission: "book",
                },
            },
            {
                path: "lp",
                name: "LP",
                component: () => import("../views/lp/lp.vue"),
                meta: {
                    requiresAuth: true,
                    isAdmin: false,
                    permission: "lp",
                },
            },
            {
                path: "lp/mobile",
                name: "LpMobile",
                component: () => import("../views/lp/lpMobile.vue"),
                meta: {
                    requiresAuth: true,
                    isAdmin: false,
                    permission: "lp",
                },
            },
            {
                path: "/search",
                name: "SearchHome",
                component: () => import("../views/search/Search.vue"),
                meta: {
                    requiresAuth: true,
                    isAdmin: false,
                    permission: "search",
                },
            },
            {
                path: "/k8s/monitor",
                name: "MonitorK8S",
                component: () => import("../views/k8s/index.vue"),
                meta: {
                    requiresAuth: true,
                    isAdmin: false,
                    permission: ["k8s", "index"],
                },
            },
            {
                path: "/copy-trade",
                name: "CopyTrade",
                component: () => import("../views/copy-trade/index.vue"),
                meta: {
                    requiresAuth: true,
                    isAdmin: false,
                    permission: ["copyTrade", "index"],
                },
            },
            {
                path: "/alert-hub",
                name: "AlertHub",
                component: () => import("../views/alert-hub/index.vue"),
                meta: {
                    requiresAuth: true,
                    isAdmin: false,
                    permission: ["alertHub", "index"],
                },
            },
            {
                path: "/alert-hub-upgrade",
                name: "AlertHubUpgrade",
                component: () => import("../views/alert-hub-upgrade/index.vue"),
                meta: {
                    requiresAuth: true,
                    isAdmin: false,
                    permission: ["alertHub", "enableAlertHubUpgrade"],
                },
            },
            {
                path: "/ib-Monitor",
                name: "IBMonitor",
                component: () => import("../views/ib-monitor/index.vue"),
                meta: {
                    requiresAuth: true,
                    isAdmin: false,
                    permission: ["ibMonitor", "index"],
                },
            },
            {
                path: "/login-Monitor",
                name: "LoginMonitor",
                component: () => import("../views/login-monitor/index.vue"),
                meta: {
                    requiresAuth: true,
                    isAdmin: false,
                    permission: ["loginMonitor", "index"],
                },
            },
            {
                path: "/change-summary",
                name: "ChangeSummary",
                component: () => import("../views/change-summary/index.vue"),
                meta: {
                    requiresAuth: true,
                    isAdmin: false,
                    permission: ["changeSummary", "index"],
                },
            },
        ],
    },
    {
        path: "/alert",
        name: "Alert",
        component: Layout,
        children: [
            {
                path: "v2",
                name: "AlertOverviewV2",
                component: () => import("../views/alert/OverviewV2.vue"),
                meta: {
                    requiresAuth: true,
                    isAdmin: false,
                    permission: ["alert", "overview"],
                },
            },
            {
                path: "mobile",
                name: "AlertOverviewMobile",
                component: () => import("../views/alert/OverviewMobile.vue"),
                meta: {
                    requiresAuth: true,
                    isAdmin: false,
                    permission: ["alert", "overview"],
                },
            },
        ],
    },
    {
        path: "/system",
        component: Layout,
        children: [
            {
                path: "settings",
                name: "Settings",
                component: () => import("../views/settings/Settings.vue"),
                meta: {
                    requiresAuth: true,
                    isAdmin: false,
                    bread: [
                        {
                            text: i18n.t('common.account.settings'),
                            disabled: true,
                            href: "/#/system/settings",
                        },
                    ],
                    permission: "settings",
                },
            },
        ],
    },
    {
        path: "/account",
        name: "Account",
        component: Layout,
        children: [
            {
                path: "permission",
                name: "AccountPermission",
                component: () => import("../views/account/Permission.vue"),
                meta: {
                    requiresAuth: true,
                    isAdmin: false,
                    bread: [
                        {
                            text: i18n.t('common.table.permission'),
                            disabled: true,
                            href: "/#/account/permission",
                        },
                    ],
                    permission: ["account", "permission"],
                },
            },
            {
                path: "management",
                name: "AccountManagement",
                component: () => import("../views/account/Management.vue"),
                meta: {
                    requiresAuth: true,
                    isAdmin: false,
                    bread: [
                        {
                            text: i18n.t('common.account.security'),
                            disabled: true,
                            href: "/account/management",
                        },
                    ],
                    permission: ["account", "management"],
                },
            },
            {
                path: "security",
                name: "AccountSecurity",
                component: () => import("../views/account/Security.vue"),
                meta: {
                    requiresAuth: true,
                    isAdmin: false,
                    bread: [
                        {
                            text: i18n.t('common.account.security'),
                            disabled: true,
                            href: "/#/account/security",
                        },
                    ],
                    permission: ["account", "profile"],
                },
            },
        ],
    },
    {
        path: "/signin",
        name: "Signin",
        component: () => import("../views/account/Signin.vue"),
    },
    {
        path: "/forget-password",
        name: "ForgetPassword",
        component: () => import("../views/account/ForgetPassword.vue"),
    },
    {
        path: "/reset-password",
        name: "ResetPassword",
        component: () => import("../views/account/ResetPassword.vue"),
    },
];

const router = new VueRouter({
    routes,
});

router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
        router.replace(targetPath);
    }
});

export default router;
